module.exports = "/* ---------------------------------------------------\n    CONTENT STYLE\n----------------------------------------------------- */\n#content {\n  width: calc(100% - 250px);\n  padding: 40px;\n  min-height: 100vh;\n  -webkit-transition: all 0.3s;\n  transition: all 0.3s;\n  position: absolute;\n  top: 0;\n  right: 0; }\n#content.active {\n  width: 100%; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/pages/cargar-iglesias-csv/cargar-iglesias-csv.component.scss
// module id = ./src/app/admin/pages/cargar-iglesias-csv/cargar-iglesias-csv.component.scss
// module chunks = main